import { z } from 'zod'

export const streetSchema = z
  .string({ required_error: 'Address is a required field' })
  .trim()
